import { Box, Heading, Text, Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { appColors } from '../constants/theme';

export default function NotFound() {
  return (
    <Box
      textAlign="center"
      py={20}
      px={6}
      minH="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Heading
        display="inline-block"
        as="h2"
        size="7xl"
        backgroundClip="text"
        colorPalette="purple"
        color={appColors.primary}
      >
        404
      </Heading>
      <Text fontSize="18px" mt={3} mb={2}>
        Page Not Found
      </Text>
      <Text color="gray.500" mb={6}>
        The page you’re looking for doesn’t exist or has been moved.
      </Text>

      <Button colorScheme="purple" variant="solid" asChild>
        <Link to="/">Go to Home</Link>
      </Button>
    </Box>
  );
}
